import React from 'react'
import ShowProductOptions from "./show-prouct-options";
import ShowProductLink from "./show-prouct-link";
import ShowAddProductToShopify from "./show-add-shopify-product";

const ShowProductDetail = ({product}) => {

    return (
        <>
            <div className="flex flex-wrap justify-start items-center">
                <div className="text-xl">
                    {product?.title} | <span className="ml-2"><ShowProductLink product={product}/></span>
                    <div className="text-lg flex flex-wrap justify-start items-center">
                        <ShowProductOptions product={product}/>
                        {product?.settings?.imagesUploaded &&
                            <div className=" ml-4 text-green-600 font-bold">Instagram Images Uploaded</div>
                        }
                    </div>
                </div>
            </div>

            {/*<div className="flex justify-between">
                <div className="text-xl flex flex-wrap justify-start">
                    {product?.title} | <span className="ml-2"><ShowProductLink product={product}/></span>
                    <div className="text-lg flex flex-wrap justify-start">
                        <ShowProductOptions product={product}/>
                        {product?.settings?.imagesUploaded &&
                            <div className=" ml-4 text-green-600 font-bold">Instagram Images Uploaded</div>
                        }
                    </div>
                </div>

                <div className="text-base float-right justify-self-end w-60">
                    <ShowAddProductToShopify productDetail={product}/>
                </div>
            </div>*/}

        </>
    )
}

export default ShowProductDetail
